import { render, staticRenderFns } from "./StandaloneDashboard.vue?vue&type=template&id=0664db2a&scoped=true&"
import script from "./StandaloneDashboard.vue?vue&type=script&lang=js&"
export * from "./StandaloneDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneDashboard.vue?vue&type=style&index=0&id=0664db2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0664db2a",
  null
  
)

export default component.exports